<template>
  <div>
    <div>
      <img class="img" src="static/qlbank/img_banner_hs.png" />
    </div>
    <div>
      <b-container>
        <b-row>
          <b-col cols="10" class="mx-auto">
            <b-card no-body class="overflow-hidden mt-2" @click="toApplyCard()">
              <b-row no-gutters>
                <b-col md="12" class="mx-auto">
                  <b-card-img
                    src="static/qlbank/img_apply_hs.png"
                    alt="Image"
                    class="rounded-0"
                  ></b-card-img>
                </b-col>
                <b-col md="12">
                  <b-card-body class="text-center">
                    <b-row>
                      <b-col cols="10" class="mx-auto">
                        <h6><b>申请储蓄卡</b></h6>
                      </b-col>
                    </b-row>
                    <b-button variant="danger" class="btnClass">申请</b-button>
                  </b-card-body>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="10" class="mx-auto">
            <b-card
              no-body
              class="overflow-hidden mt-2"
              @click="toQueryOrder()"
            >
              <b-row no-gutters>
                <b-col md="12" class="mx-auto">
                  <b-card-img
                    src="static/qlbank/img_query_hs.png"
                    alt="Image"
                    class="rounded-0"
                  ></b-card-img>
                </b-col>
                <b-col md="12">
                  <b-card-body class="text-center">
                    <b-row>
                      <b-col cols="10" class="mx-auto">
                        <h6><b>进度查询</b></h6>
                      </b-col>
                    </b-row>
                    <b-button variant="danger" class="btnClass">查询</b-button>
                  </b-card-body>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>
<script>
export default {
  name: "Home_ql",
  data() {
    return {};
  },
  mounted: function () {
    // console.log('Home_hs mounted')
    this.$store.commit("ql/resetState");
    //初始入口 1 申请卡面，2 查询进度 -1默认值
    sessionStorage.setItem("entrance", -1);
    let storeStr = JSON.stringify(this.$store.state.ql);
    // console.log('storeStr:' + storeStr)
  },
  methods: {
    toApplyCard: function () {
      sessionStorage.setItem("entrance", 1);
      // console.log(this.$store.state.ql);
      this.$router.push({
        name: "ApplyCard_ql",
      });
    },
    toQueryOrder: function () {
      sessionStorage.setItem("entrance", 2);
      // console.log(this.$store.state.ql);
      this.$router.push({
        name: "QueryOrder_ql",
      });
    },
  },
};
</script>

<style scoped>
.img {
  width: 100vw;
}

.btnClass {
  font-size: 14px;
  padding-left: 32px;
  padding-right: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/qilubank/Home_ql.vue